import type { TemplateGroup } from '../schemas';

export const DEFAULT_TEMPLATE_GROUPS: TemplateGroup[] = [
  {
    id: 'frontespizio',
    label: 'Società e stabilimento',
    order: 1,
    icon: 'domain',
  },
  {
    id: 'centrali',
    label: 'Impianti',
    order: 2,
    icon: 'factory',
  },
  {
    id: 'verifiche-sopralluogo',
    label: 'Verifiche Sopralluogo',
    order: 3,
    icon: 'fact_check',
  },
  {
    id: 'chiusura-azioni',
    label: 'Chiusura',
    order: 4,
    icon: 'assignment_turned_in',
  },
];
